import styled from '@emotion/styled'
import usePagination from '@src/hooks/navigation/usePagination'
import NextBtn from './NextBtn'
import PageBtn from './PageBtn'
import PrevBtn from './PrevBtn'

type PropsType = {
	onChangePage?: (number: number) => void
	itemPerPage: number
	totalItem: number
	currPage: number
	displayNum?: number
} & React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>

const Pagination = ({
	onChangePage,
	itemPerPage,
	totalItem,
	currPage: initCurrPage,
	displayNum = 9,
	...rest
}: PropsType) => {
	const { beginNum, endNum, prevNum, nextNum, currPage, selectPage } = usePagination({
		totalPage: Math.ceil(totalItem / itemPerPage),
		displayNum,
		currPage: initCurrPage,
		onChangePage,
	})

	const pageBtnList = []
	if (beginNum && endNum) {
		for (let i = beginNum; i <= endNum; i += 1) {
			pageBtnList.push(
				<PageBtn
					key={`pagination-key-index-${i}`}
					currPage={currPage}
					page={i}
					selectPage={selectPage}
				/>,
			)
		}
	}

	return (
		<PaginationWrapper {...rest}>
			{prevNum && <PrevBtn selectPage={selectPage} page={prevNum} />}
			{pageBtnList}
			{nextNum && <NextBtn selectPage={selectPage} page={nextNum} />}
		</PaginationWrapper>
	)
}

export const PaginationWrapper = styled.div`
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	margin: auto;
`

export default Pagination
